import styled from 'styled-components'
import Modal from 'antd/lib/modal'
import { GRAY_DARK, GRAY_LIGHTEST, RED, TRANSPARENT } from '../../theme/colors'
import Check from '../../assets/Check.svg'

interface ImagePreviewProps {
  src: string
  selected?: boolean
}

export const Container = styled.div`
`

export const Title = styled.div`
  color: ${GRAY_DARK};
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
`

export const List = styled.div`
  padding-top: 22px;
  height: 70vh;
  overflow: auto;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  align-items: center;

  @media (min-width: 320px) and (max-width: 480px) {
    max-height: 80vh;
  }
`

export const Images = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 5px;
  row-gap: 15px;
  justify-items: center;
`

export const ImageContainer = styled.div`
  width: 200px;
  background-color: ${GRAY_LIGHTEST};
  @media (max-width: 768px) {
    width: 188px;
    @media (max-width: 480px) {
      width: 170px;
    }
  }
  @media (max-width: 320px) {
    width: 140px;
  }
`

export const Image = styled.div`
  background-size: cover;
  background-position: center;
  background-image: url('${({ src }: ImagePreviewProps) => src || ''}');
  width: 100%;
  height: 200px;
  position: relative;
  border: ${({ selected }: ImagePreviewProps) => selected ? '2px' : '1px'} solid;
  border-color: ${({ selected }: ImagePreviewProps) => selected ? RED : TRANSPARENT};
  &:hover {
    cursor: pointer;
  }
  &::after {
    content: ${({ selected }: ImagePreviewProps) => selected ? `url(${Check})` : '""'};
    background: ${RED};
    width: 20px;
    height: 20px;
    position: absolute;
    top: -10px;
    right: -10px;
    display: ${({ selected }: ImagePreviewProps) => selected ? 'flex' : 'none'};
    justify-content: center;
    align-items: baseline;
    border-radius: 10px;
  }
  @media (max-width: 320px) {
    height: 140px;
  }
`

export const modalStyle = { top: 20, paddingBottom: '96px' }

export const StyledModal = styled(Modal)`
  .ant-modal-footer {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    width: 100%;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    .ant-modal-footer {
      justify-content: space-between;
    }
  }
  .ant-modal-footer .ant-btn {
    flex: 1;
    height: 40px;
    width: 170px;
    @media (max-width: 375px) {
      width: 162px;
    }
    @media (max-width: 320px) {
      width: 136px;
    }
    border-radius: 22px;
    padding-inline: 24px;
    font-size: 14px;
    font-weight: 600;
    background: #FFF;
    color: #302628;
    border: 1.5px solid #131112;
    box-shadow: none;
    &:hover {
      background: #131112;
      color: #FFF;
      border-color: #131112;
    }
  }
  .ant-modal-footer .ant-btn-primary {
    background: #302628 !important;
    color: #FFF !important;
    border: none !important;
    &:hover {
      background: #FFF !important;
      color: #302628 !important;
      border: 1.5px solid #302628 !important;
    }
  }
  @media (min-width: 320px) and (max-width: 480px) {
    max-width: calc(100vw - 8px) !important;
    margin-left: 4px;
    margin-right: 4px;
  }
`

export const bodyStyle = { padding: '12px' }

export const NotFound = styled.div`
  font-size: 18px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/AssetsModal/styledComponents.tsx